import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import HighchartsChart from '../HighchartsChart';
import Chart from '../Chart';
import XAxis from '../XAxis';
import YAxis from '../YAxis';
var defaultSparklinePlotOptions = {
  series: {
    animation: false,
    lineWidth: 1,
    shadow: false,
    states: {
      hover: {
        lineWidth: 1
      }
    },
    marker: {
      radius: 1,
      states: {
        hover: {
          radius: 2
        }
      }
    },
    fillOpacity: 0.25
  }
};
var EMPTY_ARRAY = [];
var EMPTY_OBJECT = {};
var ZERO_ARRAY = [0];
var LABELS_DISABLED = {
  enabled: false
};
var DEFAULT_MARGIN = [2, 0, 2, 0];

var HighchartsSparkline = function HighchartsSparkline(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 20 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 120 : _ref$width,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? DEFAULT_MARGIN : _ref$margin,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? EMPTY_OBJECT : _ref$style,
      series = _ref.series,
      children = _ref.children,
      _ref$plotOptions = _ref.plotOptions,
      plotOptions = _ref$plotOptions === void 0 ? defaultSparklinePlotOptions : _ref$plotOptions,
      rest = _objectWithoutProperties(_ref, ["height", "width", "margin", "style", "series", "children", "plotOptions"]);

  var chartStyle = useMemo(function () {
    return _objectSpread({
      overflow: 'visible'
    }, style);
  }, [style]);
  var hasSeriesProp = !!series; // If you want to use functionality like Tooltips, pass the data component on the `series` prop

  var Series = hasSeriesProp ? series : children;
  return /*#__PURE__*/React.createElement(HighchartsChart, _extends({
    plotOptions: plotOptions
  }, rest), /*#__PURE__*/React.createElement(Chart, {
    height: height,
    width: width,
    animation: false,
    backgroundColor: null,
    borderWidth: 0,
    margin: margin,
    style: chartStyle,
    skipClone: true
  }), /*#__PURE__*/React.createElement(XAxis, {
    labels: LABELS_DISABLED,
    startOnTick: false,
    endOnTick: false,
    tickPositions: EMPTY_ARRAY
  }), /*#__PURE__*/React.createElement(YAxis, {
    id: "sparkline",
    labels: LABELS_DISABLED,
    startOnTick: false,
    endOnTick: false,
    tickPositions: ZERO_ARRAY
  }, Series), hasSeriesProp && /*#__PURE__*/React.createElement(React.Fragment, null, children));
};

export default HighchartsSparkline;